import { render, staticRenderFns } from "./driverInfo.vue?vue&type=template&id=2cfb7073&scoped=true"
import script from "./driverInfo.vue?vue&type=script&lang=js"
export * from "./driverInfo.vue?vue&type=script&lang=js"
import style0 from "./driverInfo.vue?vue&type=style&index=0&id=2cfb7073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb7073",
  null
  
)

export default component.exports